/// Product main ///
let productVariantsCache = null;
let selectedOptions = {};
let selectedOptionsInitialized = false;
let currentVariant = null;

let galleryElement = null;
let galleryItems = [];
let navDotsContainer = null;
let prevArrow = null;
let nextArrow = null;
let currentIndex = 0;

let productHeightsInitialized = false;
let singleImageAnimated = false;

/// Helpers ///
function getProductVariants() {
  if (Array.isArray(productVariantsCache) && productVariantsCache.length) {
    return productVariantsCache;
  }
  if (Array.isArray(window.productVariants)) {
    productVariantsCache = window.productVariants;
  } else {
    productVariantsCache = [];
  }
  return productVariantsCache;
}

function getCurrencySymbol() {
  return window.currencySymbol || '';
}

function getProductStrings() {
  const fallback = {
    addToCart: 'Add to cart',
    soldOut: 'Sold out'
  };
  if (!window.productStrings) {
    return fallback;
  }
  return {
    addToCart: window.productStrings.addToCart || fallback.addToCart,
    soldOut: window.productStrings.soldOut || fallback.soldOut
  };
}

/// Product gallery ///
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

function updateDots() {
  if (!navDotsContainer) return;
  const dots = navDotsContainer.querySelectorAll('.nav-dot');
  dots.forEach(function (dot, index) {
    dot.classList.toggle('active', index === currentIndex);
  });
}

function updateCursor(itemElement, event) {
  if (!itemElement) return;
  if (galleryItems.length > 1 && event) {
    const rect = itemElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    if (x < rect.width / 2) {
      itemElement.classList.add('cursor-left');
      itemElement.classList.remove('cursor-right');
    } else {
      itemElement.classList.add('cursor-right');
      itemElement.classList.remove('cursor-left');
    }
  } else {
    itemElement.classList.remove('cursor-left');
    itemElement.classList.remove('cursor-right');
    itemElement.style.cursor = 'auto';
  }
}

function updateMediaPosition() {
  if (!galleryItems.length) return;

  if (galleryItems.length > 1) {
    if (window.matchMedia('(min-width: 749px)').matches) {
      galleryItems.forEach(function (item, index) {
        item.style.transform = '';
        item.style.transition = '';
        if (index === currentIndex) {
          item.classList.add('active');
          item.classList.add('fade-in');
          setTimeout(function () {
            item.classList.remove('fade-in');
          }, 300);
          if (item.tagName === 'VIDEO') {
            item.play();
          }
        } else {
          item.classList.remove('active');
          if (item.tagName === 'VIDEO') {
            item.pause();
            item.currentTime = 0;
          }
        }
      });
    } else {
      const offset = currentIndex * -100;
      galleryItems.forEach(function (item, index) {
        item.style.transform = 'translateX(' + offset + '%)';
        item.style.transition = isTouchDevice() ? 'transform 0.25s ease' : 'none';
        if (index === currentIndex) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
      if (!isTouchDevice() && galleryItems[currentIndex]) {
        galleryItems[currentIndex].classList.add('fade-in');
        setTimeout(function () {
          galleryItems[currentIndex].classList.remove('fade-in');
        }, 300);
      }
    }
    updateDots();
    } else {
    const item = galleryItems[0];
    if (!item) return;

    item.style.transform = '';
    item.style.transition = '';
    item.classList.add('active');

    if (!singleImageAnimated) {
      item.classList.add('fade-in');
      setTimeout(function () {
        item.classList.remove('fade-in');
      }, 300);
      singleImageAnimated = true;
    }

    if (item.tagName === 'VIDEO') {
      item.play();
    }
  }
}



function handleArrowClick(direction) {
  if (!galleryItems.length || galleryItems.length <= 1) return;
  if (direction === 'left') {
    currentIndex = (currentIndex - 1 + galleryItems.length) % galleryItems.length;
  } else if (direction === 'right') {
    currentIndex = (currentIndex + 1) % galleryItems.length;
  }
  updateMediaPosition();
}

function handleSwipe(direction) {
  if (!galleryItems.length || galleryItems.length <= 1) return;
  if (direction === 'left') {
    currentIndex = (currentIndex + 1) % galleryItems.length;
  } else if (direction === 'right') {
    currentIndex = (currentIndex - 1 + galleryItems.length) % galleryItems.length;
  }
  updateMediaPosition();
}


function scrollToVariantMedia(selectedVariant) {
  if (!selectedVariant || !galleryItems.length) return;
  const variantImage = selectedVariant.featured_image;
  if (!variantImage) return;

  const srcPart = variantImage.src;
  if (!srcPart) return;

  let foundIndex = -1;
  galleryItems.forEach(function (item, index) {
    if (item.tagName === 'IMG' && item.src.indexOf(srcPart) !== -1) {
      foundIndex = index;
    }
  });

  if (foundIndex !== -1 && foundIndex !== currentIndex) {
    currentIndex = foundIndex;
    updateMediaPosition();
  }
}

function initProductGallery(scope) {
  const container = scope || document;
  galleryElement = container.querySelector('#gallery');
  if (!galleryElement) return;

  galleryItems = Array.from(galleryElement.querySelectorAll('.product__item-img, .product__item-video'));
  if (!galleryItems.length) return;

  prevArrow = document.getElementById('prev-arrow');
  nextArrow = document.getElementById('next-arrow');
  navDotsContainer = document.getElementById('nav-dots');

  if (navDotsContainer) {
    navDotsContainer.innerHTML = '';
    galleryItems.forEach(function (item, index) {
      const dot = document.createElement('div');
      dot.classList.add('nav-dot');
      if (index === currentIndex) {
        dot.classList.add('active');
      }
      dot.addEventListener('click', function () {
        currentIndex = index;
        updateMediaPosition();
      });
      navDotsContainer.appendChild(dot);
    });
  }

  if (prevArrow) {
    prevArrow.addEventListener('click', function () {
      handleArrowClick('left');
    });
  }

  if (nextArrow) {
    nextArrow.addEventListener('click', function () {
      handleArrowClick('right');
    });
  }

  galleryItems.forEach(function (item) {
    item.addEventListener('mousemove', function (event) {
      updateCursor(item, event);
    });
  });

  if (galleryElement && !isTouchDevice()) {
    galleryElement.addEventListener('click', function (event) {
      const rect = galleryElement.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const totalWidth = rect.width;
      const direction = x < totalWidth / 2 ? 'right' : 'left';
      handleSwipe(direction);
    });
  }

    if (galleryElement && isTouchDevice()) {
    if (galleryItems.length <= 1) {
      return;
    }

    let touchStartX = 0;
    let touchStartY = 0;
    let lastTouchX = 0;
    let isDragging = false;
    let dragInitialized = false;

    galleryElement.addEventListener('touchstart', function (evt) {
      const touch = evt.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      lastTouchX = touch.clientX;
      isDragging = false;
      dragInitialized = false;
    }, { passive: true });

    galleryElement.addEventListener('touchmove', function (evt) {
      const touch = evt.touches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;
      lastTouchX = touch.clientX;

      if (!dragInitialized) {
        if (Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY)) {
          dragInitialized = true;
          isDragging = true;
        } else {
          return;
        }
      }

      if (!isDragging) return;

      evt.preventDefault();

      const galleryWidth = galleryElement.offsetWidth || 1;
      const movePercent = (deltaX / galleryWidth) * 100;
      const baseOffset = currentIndex * -100;
      const offset = baseOffset + movePercent;

      galleryItems.forEach(function (item) {
        item.style.transition = 'none';
        item.style.transform = 'translateX(' + offset + '%)';
      });
    }, { passive: false });

    galleryElement.addEventListener('touchend', function () {
      if (!dragInitialized || !isDragging) {
        updateMediaPosition();
        return;
      }

      const deltaX = lastTouchX - touchStartX;

      if (Math.abs(deltaX) > 50) {
        if (deltaX < 0) {
          currentIndex = (currentIndex + 1) % galleryItems.length;
        } else {
          currentIndex = (currentIndex - 1 + galleryItems.length) % galleryItems.length;
        }
      }

      galleryItems.forEach(function (item) {
        item.style.transition = '';
      });

      updateMediaPosition();
      isDragging = false;
      dragInitialized = false;
    }, { passive: true });
  }


  const hasVariantButtons = document.querySelector('.option-value');
  if (!hasVariantButtons) {
    updateMediaPosition();
  }
}

/// Product tables ///
function initProductTables(scope) {
  const container = scope || document;
  container.querySelectorAll('table').forEach(function (table) {
    if (table.closest('.product-table')) return;
    const wrapper = document.createElement('div');
    wrapper.classList.add('product-table');
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
}

/// Product heights ///
function setProductInfoHeight() {
  if (window.matchMedia('(min-width: 749px)').matches) {
    var header = document.getElementById('shopify-section-header');
    var productInfo = document.querySelector('.product-info');
    var productImages = document.querySelector('.figureImg');
    var productButtons = document.querySelector('.product-info__main');

    if (header && productInfo && productImages && productButtons) {
      var headerHeight = header.offsetHeight;
      productImages.style.height = 'calc(95vh - ' + headerHeight + 'px)';
      productInfo.style.minHeight = 'calc(95vh - ' + headerHeight + 'px)';
      productButtons.style.height = 'calc(95vh - ' + headerHeight + 'px)';
    }
  } else {
    var productInfoReset = document.querySelector('.product-info');
    var productImagesReset = document.querySelector('.figureImg');
    var productButtonsReset = document.querySelector('.product-info__main');
    if (productInfoReset) productInfoReset.style.minHeight = '';
    if (productImagesReset) productImagesReset.style.height = '';
    if (productButtonsReset) productButtonsReset.style.height = '';
  }

  if (galleryItems && galleryItems.length && selectedOptionsInitialized) {
    updateMediaPosition();
  }
}


function initProductHeights() {
  setProductInfoHeight();
  if (!productHeightsInitialized) {
    productHeightsInitialized = true;
    window.addEventListener('resize', setProductInfoHeight);
  }
}

/// Product accordions ///
function initAccordions(scope) {
  const container = scope || document;

  ['acc-pc', 'acc-mobile'].forEach(function (groupClass) {
    const accordions = container.querySelectorAll('.' + groupClass);
    if (!accordions.length) return;

    if (accordions.length === 1) {
      accordions.forEach(function (acc) {
        acc.classList.remove('first-accordion', 'last-accordion', 'only-accordion');
      });
      accordions[0].classList.add('only-accordion');
    } else {
      accordions.forEach(function (acc) {
        acc.classList.remove('first-accordion', 'last-accordion', 'only-accordion');
      });
      accordions[0].classList.add('first-accordion');
      accordions[accordions.length - 1].classList.add('last-accordion');
    }
  });

  container.querySelectorAll('.accordion-container').forEach(function (accordionContainer) {
    const toggleButton = accordionContainer.querySelector('.accordion-toggle');
    const content = accordionContainer.querySelector('.accordion-content');
    if (!toggleButton || !content) return;

    if (toggleButton.dataset.accordionBound === 'true') return;
    toggleButton.dataset.accordionBound = 'true';

    const isPc = accordionContainer.classList.contains('acc-pc');
    const groupSelector = isPc ? '.acc-pc' : '.acc-mobile';

    toggleButton.addEventListener('click', function () {
      const isOpen = toggleButton.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll(groupSelector).forEach(function (containerEl) {
        const otherToggle = containerEl.querySelector('.accordion-toggle');
        const otherContent = containerEl.querySelector('.accordion-content');
        if (!otherToggle || !otherContent) return;

        otherToggle.setAttribute('aria-expanded', 'false');
        otherContent.style.maxHeight = null;
      });

      if (!isOpen) {
        toggleButton.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
        content.querySelectorAll('img').forEach(function (img) {
  if (!img.complete) {
    img.addEventListener('load', function () {
      if (toggleButton.getAttribute('aria-expanded') === 'true') {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    }, { once: true });
  }
});
      } else {
        toggleButton.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = null;
      }
    });
  });
}

/// Price ///
/// Price ///
function updatePriceDisplay(selectedVariant) {
  const variants = getProductVariants();
  if (!variants.length) return;

  const variantForPrice = selectedVariant || variants[0];

  const priceCurrentEls = document.querySelectorAll('[data-product-price-current]');
  if (!priceCurrentEls.length) return;

  priceCurrentEls.forEach(function (priceCurrentEl) {
    priceCurrentEl.textContent = formatPrice(variantForPrice.price);
    priceCurrentEl.classList.remove('product-price__current--sale');

    const container = priceCurrentEl.closest('.product-price-block');
    const priceCompareEl = container
      ? container.querySelector('[data-product-price-compare]')
      : null;

    if (!priceCompareEl) return;

    const hasSale =
      variantForPrice.compare_at_price &&
      variantForPrice.compare_at_price > variantForPrice.price;

    if (hasSale) {
      priceCompareEl.textContent = formatPrice(variantForPrice.compare_at_price);
      priceCompareEl.classList.remove('product-price__compare--hidden');
      priceCurrentEl.classList.add('product-price__current--sale');
    } else {
      priceCompareEl.textContent = '';
      priceCompareEl.classList.add('product-price__compare--hidden');
    }
  });
}



/// Product variants ///
function formatPrice(priceInCents) {
  const symbol = getCurrencySymbol();
  return symbol + (priceInCents / 100).toFixed(2);
}

function findMatchingVariant() {
  const variants = getProductVariants();
  if (!variants.length) return null;

  return (
    variants.find(function (variant) {
      return (
        Object.keys(selectedOptions).every(function (optionKey) {
          return variant[optionKey] === selectedOptions[optionKey];
        }) && variant.available
      );
    }) || null
  );
}

function updateActiveStates() {
  document.querySelectorAll('.option-value').forEach(function (button) {
    const optionIndex = button.getAttribute('data-option');
    const key = 'option' + optionIndex;
    if (selectedOptions[key] === button.getAttribute('data-value')) {
      button.classList.add('active');
    } else {
      button.classList.remove('active');
    }
  });
}

function updateOptionsAvailability() {
  const variants = getProductVariants();
  if (!variants.length) return;

  const strings = getProductStrings();
  const addToCartButton = document.querySelector('.product-info__cart-btn');
  const allVariantsSoldOut = !variants.some(function (variant) {
    return variant.available;
  });

  if (addToCartButton && allVariantsSoldOut) {
    addToCartButton.textContent = strings.soldOut;
    addToCartButton.disabled = true;
    document.querySelectorAll('.option-value').forEach(function (button) {
      button.classList.add('disabled');
    });
    return;
  }

  document.querySelectorAll('.option-value').forEach(function (button) {
    const optionIndex = button.getAttribute('data-option');
    const value = button.getAttribute('data-value');
    const key = 'option' + optionIndex;

    const isAvailable = variants.some(function (variant) {
      let matchesOtherSelectedOptions = true;
      Object.keys(selectedOptions).forEach(function (selectedOptionKey) {
        if (selectedOptionKey !== key) {
          if (variant[selectedOptionKey] !== selectedOptions[selectedOptionKey]) {
            matchesOtherSelectedOptions = false;
          }
        }
      });
      return matchesOtherSelectedOptions && variant.available && variant[key] === value;
    });

    if (!isAvailable) {
      button.classList.add('disabled');
    } else {
      button.classList.remove('disabled');
    }
  });
}

function updateVariantAndPrice() {
  const strings = getProductStrings();
  const variants = getProductVariants();
  if (!variants.length) return;

  const matchingVariant = findMatchingVariant();
  const cartButton = document.querySelector('.product-info__cart-btn');
  if (!cartButton) return;

  if (matchingVariant) {
    currentVariant = matchingVariant;

    const form = document.getElementById('AddToCartForm');
    if (form) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = matchingVariant.id;
      }
    }

    const formattedPrice = formatPrice(matchingVariant.price);
    cartButton.disabled = false;
    cartButton.innerHTML = strings.addToCart + ' — ' + formattedPrice;

    scrollToVariantMedia(matchingVariant);

    ensureSomeImageVisible();
  } else {
    cartButton.disabled = true;
    cartButton.textContent = strings.soldOut;

    ensureSomeImageVisible();
  }

  updatePriceDisplay(matchingVariant);
}
function ensureSomeImageVisible() {
  if (galleryItems && galleryItems.length) {
    const hasActive = galleryItems.some(item => item.classList.contains('active'));
    if (!hasActive) {
      currentIndex = 0;
      updateMediaPosition();
    }
  }
}




function initializeSelections() {
  const variants = getProductVariants();
  if (!variants.length) return;

  const firstAvailableVariant = variants.find(function (variant) {
    return variant.available;
  });

  const baseVariant = firstAvailableVariant || variants[0];

  selectedOptions = {};
  baseVariant.options.forEach(function (optionValue, index) {
    const optionIndex = index + 1;
    const optionButtons = document.querySelectorAll(
      '.option-value[data-option="' + optionIndex + '"]'
    );

    optionButtons.forEach(function (button) {
      if (button.getAttribute('data-value') === optionValue) {
        button.classList.add('active');
      }
    });

    selectedOptions['option' + optionIndex] = optionValue;
  });

  selectedOptionsInitialized = true;
  updateOptionsAvailability();
  updateVariantAndPrice();
}


function attachVariantHandlers(scope) {
  const container = scope || document;
  const variantButtons = container.querySelectorAll('.option-value');
  if (!variantButtons.length) return;

  variantButtons.forEach(function (button) {
    if (button.dataset.variantBound === 'true') return;
    button.dataset.variantBound = 'true';

    button.addEventListener('click', function () {
      const optionIndex = this.getAttribute('data-option');
      const value = this.getAttribute('data-value');
      const key = 'option' + optionIndex;

      if (this.classList.contains('disabled')) {
        return;
      }

      selectedOptions[key] = value;
      updateActiveStates();
      updateOptionsAvailability();
      updateVariantAndPrice();
    });
  });
}

function initProductVariants(scope) {
  const variants = getProductVariants();
  if (!variants.length) return;

  if (!selectedOptionsInitialized) {
    initializeSelections();
  } else {
    updateActiveStates();
    updateOptionsAvailability();
    updateVariantAndPrice();
  }

  attachVariantHandlers(scope);
}

/// Init hooks ///
function initProductMain(scope) {
  initProductGallery(scope);
  initProductTables(scope);
  initAccordions(scope);
  initProductHeights();
  initProductVariants(scope);
}

document.addEventListener('DOMContentLoaded', function () {
  initProductMain(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initProductMain(event.target);
});
/* Variant color-image fix v2 — runs independently of price/app errors */
function imageFileKey(u) {
  if (!u) return '';
  u = String(u).split('?')[0];
  return u.substring(u.lastIndexOf('/') + 1);
}
function swapVariantImage(selectedVariant) {
  if (!selectedVariant || !galleryItems.length) return;
  var vi = selectedVariant.featured_image;
  if (!vi) return;
  var key = imageFileKey(vi.src);
  if (!key) return;
  for (var i = 0; i < galleryItems.length; i++) {
    var it = galleryItems[i];
    if (it.tagName === 'IMG' && imageFileKey(it.getAttribute('src') || it.src) === key) {
      if (i !== currentIndex) { currentIndex = i; updateMediaPosition(); }
      return;
    }
  }
}
scrollToVariantMedia = function (selectedVariant) { swapVariantImage(selectedVariant); };
function bindVariantImageSwap() {
  document.querySelectorAll('.option-value').forEach(function (btn) {
    if (btn.dataset.imgSwapBound === 'true') return;
    btn.dataset.imgSwapBound = 'true';
    btn.addEventListener('click', function () {
      var opts = {};
      document.querySelectorAll('.option-value.active, .option-value').forEach(function (b) {});
      var val = this.getAttribute('data-value');
      var idx = this.getAttribute('data-option');
      var picked = {};
      document.querySelectorAll('.option-value').forEach(function (b) {
        if (b.classList.contains('active')) picked['option' + b.getAttribute('data-option')] = b.getAttribute('data-value');
      });
      picked['option' + idx] = val;
      var match = (window.productVariants || []).find(function (v) {
        return Object.keys(picked).every(function (k) { return v[k] === picked[k]; });
      });
      if (match) setTimeout(function () { swapVariantImage(match); }, 0);
    });
  });
}
document.addEventListener('DOMContentLoaded', bindVariantImageSwap);
document.addEventListener('shopify:section:load', bindVariantImageSwap);
